import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "hooks/useHistory";
import { webAppBackHandler } from "@Utils/webApputils";
import { WEB_VIEW_APP_EVENTS } from "@Utils/webApputils/analyticEvents";
import { initWebViewEventListener, subscribeToWebViewEvent } from "@Utils/webviewEvents";
import { authMiddlewareClient } from "@App/appReducer";
import {
  toggleShowWidgetState,
  setOpenAmberCopilot,
} from "@Pages/PropertyPage/components/ZendeskChat/ChatBotReducer";

export function useWebViewEvents() {
  const dispatch = useDispatch();
  const history = useHistory();

  const singularDeeplinkHandler = (payload: { url: string }) => {
    if (payload?.url || payload?.url === "") {
      const targetUrl = `/${payload.url}`;
      history.push(targetUrl);
    } else {
      console.log("[WebView] No URL in payload, skipping navigation");
    }
  };
  const fcmTokenUpdatedHandler = (payload: { token: string }) => {
    if (payload?.token) {
      window.fcmToken = payload.token;
    }
  };

  const backActionHandler = () => {
    webAppBackHandler(history);
  };

  const userAuthHandler = (payload: { authToken: string }) => {
    window.localStorage.setItem("user_auth_token", payload?.authToken);
    dispatch(authMiddlewareClient(true));
  };
  const handleZendeskWidget = (payload: { isOpened: boolean }) => {
    if (!payload?.isOpened) {
      dispatch(toggleShowWidgetState(false));
      dispatch(setOpenAmberCopilot(false));
      // @ts-ignore
      if (typeof zE === "function") {
        // @ts-ignore
        zE("messenger", "close");
      }

      // @ts-ignore
      if (typeof wn !== "undefined" && typeof wn.hideWidget === "function") {
        // @ts-ignore
        wn.hideWidget();
      }
    }
  };

  useEffect(() => {
    initWebViewEventListener();

    const unsubscribeFcmTokenUpdated = subscribeToWebViewEvent(
      WEB_VIEW_APP_EVENTS.FCM_TOKEN_UPDATED,
      fcmTokenUpdatedHandler,
    );

    const unsubscribeSingular = subscribeToWebViewEvent(
      WEB_VIEW_APP_EVENTS.SINGULAR_DEEPLINK,
      singularDeeplinkHandler,
    );

    const unsubscribeBack = subscribeToWebViewEvent(
      WEB_VIEW_APP_EVENTS.BACK_ACTION_TRIGGERED,
      backActionHandler,
    );

    const unsubscribeUserAuth = subscribeToWebViewEvent(
      WEB_VIEW_APP_EVENTS.USER_AUTH_TOKEN,
      userAuthHandler,
    );
    const unsubscribeZendeskWidget = subscribeToWebViewEvent(
      WEB_VIEW_APP_EVENTS.ZENDESK_TOGGLE,
      handleZendeskWidget,
    );

    return () => {
      unsubscribeSingular();
      unsubscribeBack();
      unsubscribeUserAuth();
      unsubscribeZendeskWidget();
      unsubscribeFcmTokenUpdated();
    };
  }, []);
}

export default useWebViewEvents;
